import React, { useState } from "react";

import LeadsImportStep1 from "./LeadsImportStep1";
import LeadsImportStep2 from "./LeadsImportStep2";
import { Button, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { appendable_columns } from "../../../../static/brands_wholesalers_data";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const UploadFile = ({ onSubmit }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [file, setFile] = useState();
  const [type, setType] = useState('brand');
  const [tableData, setTableData] = useState();
  const [appendableColumns, setAppendableColumns] = useState(appendable_columns);

  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [uploadWarning, setUploadWarning] = useState();

  const _toggleSuccessModal = () => setSuccessModal((prev) => !prev);

  const _handleTableColumnSelect = (selectedColumn, appendedValue) => {
    // Make a copy of the current state
    const updatedData = { ...tableData };

    // Find the index of the selected column in the columns array
    const columnIndex = updatedData?.columns?.findIndex((column) => column?.Header === selectedColumn);

    // If the column is found, add the appendedValue property
    if (columnIndex !== -1) {
      updatedData.columns[columnIndex] = {
        ...updatedData?.columns[columnIndex],
        appendedValue,
      };
      console.log(selectedColumn, appendedValue)
      // Update the state with the new data
      setTableData(updatedData);
      setAppendableColumns((prev) => prev?.filter((c) => c.id !== appendedValue));
    } else {
      console.error(`Column with Header "${selectedColumn}" not found.`);
    }
  };

  const _handleTableColumnUnSelect = (selectedColumn) => {
    // Make a copy of the current state
    const updatedData = { ...tableData };

    // Find the index of the selected column in the columns array
    const columnIndex = updatedData?.columns.findIndex((column) => column?.Header === selectedColumn);

    // If the column is found, add the appendedValue property
    if (columnIndex !== -1) {
      const appendedValue = updatedData?.columns[columnIndex].appendedValue;
      updatedData.columns[columnIndex] = {
        Header: updatedData.columns[columnIndex].Header,
        accessor: updatedData.columns[columnIndex].accessor,
      };

      // Update the state with the new data
      setTableData(updatedData);

      const appendableColumn = appendable_columns?.find((c) => c.id === appendedValue);

      setAppendableColumns((prev) => [...prev, appendableColumn]);
    } else {
      console.error(`Column with Header "${selectedColumn}" not found.`);
    }
  };
  const _handleTableDataRemove = () => {
    setAppendableColumns(appendable_columns);
    setFile(null);
    setTableData(null);
    setStep(1);
  };

  const validateData = () => {
    const requiredFieldsString = appendableColumns
      .reduce((accumulator, currentValue) => {
        if (currentValue.required) {
          accumulator?.push(currentValue.label);
        }
        return accumulator;
      }, [])
      .join(", ");

    if (requiredFieldsString) {
      toast.warning(`${requiredFieldsString} ${requiredFieldsString?.includes(",") ? "fields are" : "field is"} required!`);
      return false;
    }

    return true;
  };

  const _handleSubmit = async () => {
    if (!type) return toast.info("Please select type first!")

    // Checking if all our appenable columns are appended to data
    if (!validateData()) {
      return;
    }

    setLoading(true);

    const payload = {
      type,
      data: tableData?.data,
      columns: tableData?.columns?.map((c) => ({
        Header: c?.appendedValue || c?.Header,
        accessor: c?.accessor,
      })),
    };
    const response = await onSubmit(payload);
    if (response?.statusCode === 200) {
      if (response?.warning) {
        setUploadWarning(response?.warning);
      }
      _toggleSuccessModal();
    }

    setLoading(false);
  };

  const onClose = () => {
    _toggleSuccessModal();
    navigate(-1)
  }

  return (
    <div
      style={{
        padding: '20px 0px',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        overflowX: "hidden",
      }}
    >
      <div style={{ paddingInline: "2rem" }}>
        <h1 style={{ fontSize: "30px", fontWeight: "bold" }}>
          Upload a file
        </h1>
        <p
          style={{
            color: "#999",
            fontSize: "13px",
          }}
        >
          Upload a file. This is particularly
          useful when you have a large number of contacts to import.
        </p>

        <FormGroup className="mb-0 w-25">
          <Label>Data Type</Label>
          <Input
            type="select"
            value={type}
            style={{
              backgroundColor: "white",
              textTransform: "uppercase",
              color: "#4E585E",
              fontWeight: 500,
            }}
            onChange={(e) => setType(e.target.value)}
          >
            <option value='brand'>
              Brands
            </option>
            {/* <option value='wholesaler'>
              Wholesaler
            </option> */}
            <option value='retailer'>
              Retailer
            </option>
          </Input>
        </FormGroup>

      </div>

      <hr style={{ backgroundColor: "#CFCFCF", width: "100%", zIndex: -1 }} />

      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowX: "hidden",
        }}
      >
        <LeadsImportStep1
          step={step}
          file={file}
          onFileAdd={setFile}
          tableData={tableData}
          onStepChange={(s) => step !== s && s >= 0 && setStep(s)}
          onTableDataAdd={setTableData}
          onTableDataRemove={_handleTableDataRemove}
        />

        <hr style={{ backgroundColor: "#CFCFCF", marginInline: "-1rem" }} />

        <LeadsImportStep2
          step={step}
          loading={loading}
          tableData={tableData}
          onStepChange={(s) => step !== s && s >= 0 && setStep(s)}
          onSubmit={_handleSubmit}
          appendableColumns={appendableColumns}
          setAppendableColumns={setAppendableColumns}
          onTableColumnSelect={_handleTableColumnSelect}
          onTableColumnUnSelect={_handleTableColumnUnSelect}
        />
      </Container>

      <Modal isOpen={successModal} toggle={onClose}>
        <ModalHeader toggle={onClose}>
          {"Upload Successful"}
        </ModalHeader>
        <ModalBody>
          {uploadWarning ||
            "Your file was successfully uploaded."}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default UploadFile;
